import { onBeforeUnmount, onMounted } from '@nuxtjs/composition-api'

const useClickOutside = (selectors: string[], callback: () => void) => {
  const clickOutside = (event) => {
    let contains = false
    for (const selector of selectors) {
      const el = document.querySelector(selector)
      if (el?.contains(event.target)) {
        contains = true
      }
    }
    if (!contains) {
      callback()
    }
  }

  onMounted(() => {
    document.addEventListener('click', clickOutside)
  })

  onBeforeUnmount(() => {
    document.removeEventListener('click', clickOutside)
  })
}

export default useClickOutside
